import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteConfiguracionInfracciones,
  getConfiguracionesInfracciones,
  patchConfiguracionInfracciones,
  postConfiguracionInfracciones,
} from 'api/catalogos/configuracionDeInfracciones';

// eslint-disable-next-line react/prop-types
const configuracionInfracciones = ({ permission }) => (
  <PlainCRUD
    title="Configuración infracciones"
    permission={permission}
    get={getConfiguracionesInfracciones}
    post={postConfiguracionInfracciones}
    patch={patchConfiguracionInfracciones}
    delete={deleteConfiguracionInfracciones}
    withoutState
    fields={[
      defaultFields.clave,
      {
        name: 'aplica_folio_manual',
        label: '¿Aplica folio manual?',
        type: 'select',
      },
      {
        name: 'aplica_calificar_estatus',
        label: '¿Aplica calificar estatus?',
        type: 'select',
      },
      {
        name: 'aplica_a_padrones',
        label: '¿Aplica a padrones?',
        type: 'select',
      },
      {
        name: 'aplican_advertencias',
        label: '¿Aplica advertencias?',
        type: 'select',
      },
      {
        name: 'aplican_acuses',
        label: '¿Aplica acuses?',
        type: 'select',
      },
      {
        name: 'aplica_infractor_manual',
        label: '¿Aplica infractor manual?',
        type: 'select',
      },
      {
        name: 'aplica_infraccion eatonal',
        label: '¿Aplica infracción peatonal?',
        type: 'select',
      },
      {
        name: 'agente_usuario',
        label: '¿Agente usuario?',
        type: 'select',
      },
    ]}
  />
);

export default configuracionInfracciones;
